export default __webpack_public_path__ + "strongher-devices_mobile@2x.cf5668c2.png";